import { render, staticRenderFns } from "./Tbody2.vue?vue&type=template&id=492c0a45&scoped=true&"
import script from "./Tbody2.vue?vue&type=script&lang=js&"
export * from "./Tbody2.vue?vue&type=script&lang=js&"
import style0 from "./Tbody2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Tbody2.vue?vue&type=style&index=1&id=492c0a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c0a45",
  null
  
)

export default component.exports